<template>
  <a-row type="flex" class="main-content">
    <a-col :span="12">
      <div class="header-title">
        <span>蔡旻樺</span>
        <span>Evan Tsai</span>
      </div>
      <p>
        出生於1988年，畢業於高雄海洋科技大學微電子工程系，出社會第一份工作是從事電子技術方面的公職，但由於本身喜歡繪畫，因此在工作之餘也另外進修學習繪圖軟體、視覺設計的能力，並於2015年轉職，開始踏入設計的領域，平面設計及網頁設計皆有所經歷，
        也因為這個經驗，對於日後與UI設計師在溝通協調方面，會更流暢且更能減少溝通方面的時間成本。
        而在從事設計工作時，因緣際會也接觸到WEB前端程式的部分，進而開發出另一個更濃厚的興趣，從此專心往前端程式發展，奠定未來想專心朝向前端工程師的方向。
      </p>
      <ul class="link-list">
        <li v-for="(item, index) in linkList" :key="index">
          <a :href="item.href" target="_blank">
            <font-awesome-icon :icon="item.awesomeIcon" />
            <span>{{ item.text || "" }}</span>
          </a>
        </li>
      </ul>
    </a-col>
    <a-col :span="12" class="aboutme-img">
      <img :src="aboutmeImg" />
    </a-col>
  </a-row>
</template>
<script>
import aboutmeImg from "../../assets/img/aboutme-me.png";
export default {
  name: "fullpageSection1",
  props: [],
  data() {
    return {
      aboutmeImg,
      linkList: [
        {
          awesomeIcon: ["fa", "envelope"],
          href: "mailto:dark1988128@gmail.com",
          text: "dark1988128@gmail.com"
        },
        {
          awesomeIcon: ["fab", "github"],
          href: "https://github.com/minhuatsai",
          text: "https://github.com/minhuatsai"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
#fullpage {
  .main-content {
    padding: 0 7vw;
    max-width: none;

    .aboutme-img {
      text-align: center;

      img {
        width: 100%;
        max-width: 523px;
        opacity: 0.85;
      }
    }
  }
}

@media screen and(max-width:1024px) {
  #fullpage .main-content p {
    font-size: 1.5vw;
  }
}
@media only screen and (max-height: 768px) {
  #fullpage {
    .main-content {
      .aboutme-img {
        img {
          max-height: 100vh;
          width: auto;
          max-width: none;
        }
      }
    }
  }
}
</style>
